
































import Vue from 'vue';
import Component from 'vue-class-component';
import { mdbContainer } from 'mdbvue';

@Component({
  name: 'privacy',
  components: {
    mdbContainer,
  },
})

export default class Privacy extends Vue {}

